<template>
  <div class="bg-gray-100">
    <div class="mx-auto max-w-3xl px-4 py-10 lg:px-0">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <Subheadline title="Mit heysafe auf Nummer sicher:"/>
          <ListWithIcon :list-items="listItems"/>
        </div>
        <div>
          <Subheadline title="Bekannt aus:"/>
          <div class="mt-6 grid grid-cols-3 gap-4">
            <div class="col-span-1 flex justify-center opacity-50" v-for="image in imageSources" v-bind:key="image.src">
              <img class="h-6" :src="image.src" :alt="image.alt">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Subheadline from "../../common/components/Subheadline";
import ListWithIcon from "../../common/components/ListWithIcon";

const ekomiHappy = document.getElementById('hsapp')?.dataset.ekomiHappy || '97';

const listItems = [
  {key: 1, title: 'Marktführer seit über 10 Jahren', icon: 'far fa-check'},
  {key: 2, title: 'Deutschlands fairster Preis', icon: 'far fa-check'},
  {key: 3, title: 'Renommierter Partner: AXA Versicherung', icon: 'far fa-check'},
  {key: 4, title: `${ekomiHappy} % zufriedene Kunden`, icon: 'far fa-check'},
  {key: 5, title: 'Keine Vertragslaufzeit, jederzeit kündbar', icon: 'far fa-check'},
];
const imageSources = [
  {src: '/images/welt_logo.png', alt: 'welt Logo'},
  {src: '/images/stern_logo.png', alt: 'stern Logo'},
  {src: '/images/ntv_logo.png', alt: 'ntv Logo'},
];
</script>
